<div
  class="flex items-center gap-2 flex-wrap border-b border-gray-200 pb-3 mb-4">

  <ng-container
    *ngFor="let action of actions">

    <button
      *ngIf="action.name !== 'close' && isVisible(action)"
      type="button"
      (click)="execute(action)"
      [disabled]="loading || isDisabled(action)"
      [ngClass]="{
        'bg-black text-white border-black':
          action.type === 'primary',

        'bg-[#F5F8FA] text-[#5E6278] border-gray-200':
          action.type === 'secondary'
      }"
      class="px-4 py-2 rounded text-[10px] font-bold uppercase tracking-widest border transition-all">

      {{ action.label }}

    </button>

    <button *ngIf="action.name === 'close'"
      type="button"
      [ngClass]="{
        'bg-black text-white border-black':
          action.type === 'primary',

        'bg-[#F5F8FA] text-[#5E6278] border-gray-200':
          action.type === 'secondary'
      }"
      data-kt-drawer-dismiss="true"
      class="px-4 py-2 rounded text-[10px] font-bold uppercase tracking-widest border transition-all">
      {{ action.label }}
    </button>


  </ng-container>

</div>